import amplitude from "amplitude-js";

// Amplitude instance reference
export const amplitudeInstance = amplitude.getInstance();